import PropTypes from 'prop-types';
import React from 'react';

import { getAwardsBgColor } from '$utilities/data';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

const WhiteShapeDesktop = () => {
    return (
        <svg
            fill='none'
            role='presentation'
            style={{ width: '1035px', weight: '100%' }}
            viewBox='0 0 1047 282'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M2.69027 142.729L1038.73 159.686L458 121.997'
                stroke='white'
                strokeWidth='243'/>
        </svg>
    );
};

const WhiteShapeMobile = () => {
    return (
        <svg
            fill='none'
            role='presentation'
            style={{ width: '329px', height: '100%' }}
            viewBox='0 15 338 158'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M-0.00229293 94.6972L330.065 94.6972L72.1981 62.0213'
                stroke='white'
                strokeWidth='124.812'/>
        </svg>
    );
};

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const AwardsModuleBannerStatistics = ({
    backgroundColor,
    backgroundMedia,
    body,
    heading,
    headingIcon,
    title
}) => {
    const bg = getAwardsBgColor(backgroundColor);

    return (
        <section
            className='w-full mt-80 overflow-hidden relative h-[470px] md:h-[410px] px-20 py-25 md:py-100 bg-no-repeat bg-cover bg-center bg-fixed'
            style={(backgroundMedia?.image && !backgroundMedia?.video) ? { backgroundImage: `url(${backgroundMedia?.image.src})` } : { backgroundColor: bg }}>
            {backgroundMedia?.video && (
                <div className='absolute top-0 left-0 right-0 bottom-0'>
                    <video
                        muted
                        autoPlay={true}
                        className='w-full h-full pointer-events-none'
                        controls={false}
                        loop='loop'
                        playsInline={true}
                        role='presentation'
                        src={backgroundMedia?.video.src}
                        style={{ objectFit: 'cover' }} />
                </div>
            )}

            <div className='h-full flex md:flex-row flex-col justify-center'>
                <div className='md:hidden absolute flex flex-row text-white top-20'>
                    {headingIcon && (
                        <div className='mr-10'>
                            <img
                                className='pointer-events-none'
                                height='23'
                                loading='lazy'
                                role='presentation'
                                src={headingIcon.src}
                                width='23' />
                        </div>
                    )}

                    <h2 className='self-center type-style-awards-tiny-uppercase md:type-style-awards-small-uppercase'>
                        {heading}
                    </h2>
                </div>
                <div className='hidden md:absolute -translate-x-1/2 left-1/2 top-0 h-full md:flex items-center justify-center pointer-events-none'>
                    <WhiteShapeDesktop />
                </div>
                <div className='md:hidden absolute -translate-x-1/2 left-1/2 h-full pointer-events-none'>
                    <WhiteShapeMobile />
                </div>
                <div className='relative flex md:flex-row justify-center items-center gap-40 mx-auto'>
                    <h3 className='type-style-awards-hero-uppercase'>
                        {title}
                    </h3>
                    <div className='hidden md:block md:relative md:max-w-[362px] gap-20 type-style-awards-body'>
                        <div className='absolute flex flex-row top-[-30px]'>
                            {headingIcon && (
                                <div className='mr-10'>
                                    <img
                                        className='pointer-events-none'
                                        height='23'
                                        loading='lazy'
                                        role='presentation'
                                        src={headingIcon.src}
                                        width='23' />
                                </div>
                            )}

                            <h2 className='self-center type-style-awards-tiny-uppercase md:type-style-awards-small-uppercase'>
                                {heading}
                            </h2>
                        </div>
                        <p>
                            {body}
                        </p>
                    </div>
                </div>
                <p className='md:hidden text-white absolute bottom-20 pr-20'>
                    {body}
                </p>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    backgroundColor: PropTypes.string,
    backgroundMedia: PropTypes.object,
    body: PropTypes.string,
    heading: PropTypes.string,
    headingIcon: PropTypes.object,
    title: PropTypes.string
};

AwardsModuleBannerStatistics.propTypes = propTypes;

export default AwardsModuleBannerStatistics;
